import React from 'react'
import {Link, NavLink} from 'react-router-dom'
import ReactSVG from 'react-svg'
import _ from 'lodash'
import * as re from 'recompose';

import {
    AppBar, Toolbar, Typography, Button,
    Hidden, Icon, IconButton, Drawer,
    List, ListItem, ListItemText,
    withStyles
} from 'material-ui'

import logo from './svg/carefolio_logo_WHITE.svg'
import applogo from './svg/cf-icon.svg'

const styles = theme => ({
    appBar: {
        boxShadow: 'none',
        backgroundColor: 'transparent', // theme.palette.hero,
        '& a': {
            color: theme.palette.contrast,
        },
        '& a:hover': {
            color: theme.palette.contrast,
        },
        '& a.active': {
            borderBottom: `1px solid ${theme.palette.contrast}`,
        }
    },
    flex: {
        flex: 1
    },
    logo: {
        display: 'block',
        height: 36,
        fill: theme.palette.contrast,
    },
    applogo: {
        background: "white",
        borderRadius: 10,
        minWidth: 0,
        width: 50,
        height: 50,
    },
    icon: {
        color: 'white'
    },
    drawerPaper: {
        width: 240
    },
})

const HeaderLogo = ({classes, ...props}) => (
    <Typography type="title" color="inherit" className={classes.flex}>
        <Link to="/">
            <div>
                <Button className={classes.applogo}><ReactSVG className={classes.logo} path={applogo}/></Button>
                <Button><ReactSVG className={classes.logo} path={logo}/></Button>
            </div>
        </Link>
    </Typography>
)

const links = [
    {to: '/', label: 'Home'},
    {to: '/signup', label: 'Sign up'},
]

export const MainNav = ({
    classes, nologo, open, toggleDrawer,
}) => (
    <div>
        <AppBar position="static" className={classes.appBar}>
            <Hidden smUp>
                <IconButton onClick={toggleDrawer}>
                    <Icon className={classes.icon}>menu</Icon>
                </IconButton>
            </Hidden>
            <Hidden smDown>
                <Toolbar>
                    {nologo ? <div className={classes.flex}/> : <HeaderLogo classes={classes}/>}
                    {_.map(links, lnk => (
                        <Button key={lnk.to} component={NavLink} exact
                            to={lnk.to}>{lnk.label}</Button>
                    ))}
                    <Button href="https://app.carefol.io/login">Login</Button>
                </Toolbar>
            </Hidden>
        </AppBar>
        <Drawer open={open} onClose={toggleDrawer}
            classes={{paper: classes.drawerPaper}}>
            <List>
                {_.map(links, lnk => (
                    <ListItem button component={NavLink} key={lnk.to} to={lnk.to}>
                        <ListItemText primary={lnk.label}/>
                    </ListItem>
                ))}
                <ListItem button component="a"
                    href="https://app.carefol.io/login">
                    <ListItemText primary="Login"/>
                </ListItem>
            </List>
        </Drawer>
    </div>
)

export default re.compose(
    withStyles(styles),
    re.withStateHandlers({open: false}, {
        toggleDrawer: ({open}) => () => ({open: !open})
    })
)(MainNav)



// WEBPACK FOOTER //
// ./src/components/MainNav.jsx